
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/transfer/application",
      function () {
        return require("private-next-pages/docs/transfer/application.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/transfer/application"])
      });
    }
  